import { cloneDeep }              from 'lodash-es';
import { XAxisReportLayout }      from '@/views/x-axis-report/report-edit/types/types';
import { xAxisReportConfig }      from '@/views/x-axis-report/report-edit/helpers/chart/x-axis-report-chart.config';
import { XAxisReportPanelGroups } from '@/views/x-axis-report/report-edit/helpers/x-axis-report.variables';

export const state: XAxisReportLayout = {
  hasFiltersChanged: false,
  disabledFilters: [],
  selectedFilters: [],
  isPanelOpen: true,
  isSaveReportButtonLoading: false,
  isChartLoading: false,
  isPanelButtonLoading: false,
  isChartSaved: true,
  chartConfiguration: cloneDeep(xAxisReportConfig),
  sidePanelCalculateConfiguration: {},
  panelDefaultConfiguration: {},
  groups: {
    currentElementName: '',
    activeGroupName: XAxisReportPanelGroups.FILTERS,
    [ XAxisReportPanelGroups.FUNCTIONS ]: {
      isGroupLoading: false,
      isEditMode: false,
      data: [],
    },
    [ XAxisReportPanelGroups.FILTERS ]: {
      isGroupLoading: false,
      isEditMode: false,
      data: [],
    },
    [ XAxisReportPanelGroups.X_AXIS ]: {
      isGroupLoading: false,
      isEditMode: false,
      data: [],
    },
    [ XAxisReportPanelGroups.LEGEND ]: {
      isGroupLoading: false,
      isEditMode: false,
      data: [],
    },
  },
};
